import Info from './Info';
import Layout from './Layout';
import Login from './Login';
import Petunjuk from './Petunjuk';
import PilihanUktTinggi from './PilihanUktTinggi';
import Seleksi from './Seleksi';
import Ukt from './Ukt';
import UktTinggi from './UktTinggi';
import SelesaiIsi from './SelesaiIsi';
import TungguPengumuman from './TungguPengumuman';
import TerimaSanggah from './TerimaSanggah';
import Terima from './Terima';
import Klarifikasi from './Klarifikasi';
import Biodata from './Biodata';
import BiodataCMahasiswa from './BiodataCMahasiswa';
import BiodataSelesaiIsi from './BiodataSelesaiIsi';

export {
    Info,
    Layout,
    Login,
    Petunjuk,
    PilihanUktTinggi,
    Seleksi,
    Ukt,
    UktTinggi,
    SelesaiIsi,
    TungguPengumuman,
    TerimaSanggah,
    Terima,
    Klarifikasi,
    Biodata,
    BiodataCMahasiswa,
    BiodataSelesaiIsi,
};
